module.exports = __webpack_public_path__ + "img/8.e1e92c9a.jpg";